import { render, staticRenderFns } from "./MainSolutionService.vue?vue&type=template&id=64ab4490"
import script from "./MainSolutionService.vue?vue&type=script&lang=js"
export * from "./MainSolutionService.vue?vue&type=script&lang=js"
import style0 from "./MainSolutionService.vue?vue&type=style&index=0&id=64ab4490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports